import { createAction } from '@reduxjs/toolkit';

export const requestRetrieveUserMetrics = createAction('report/retrieveUserMetrics');
export const requestDownloadUserMertics = createAction('report/downloadUserMetrics');
export const requestRetrieveDealRoomStatistics = createAction('report/retrieveDealRoomStatistics');
export const requestDownloadDealRoomStatistics = createAction('report/downloadDealRoomStatistics');
